<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Subheader :title="`${sensorId ? 'Edit' : 'Add New'} Sensor`" />

    <div class="container">
      <div class="row py-3">
        <div class="col-md-3">
          <div class="form-group">
            <label for="sensorId" class="custom-label">ID</label>
            <input id="sensorId" type="text" class="form-control shadow-none custom-input"
              placeholder="This is autogenerated" readonly v-model="saveData.id">
          </div>
        </div>
        <div class="col-md-6 mb-3" >
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">Title</label>
            <input id="assetTypeName" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.title">
          </div>
        </div>
        <div class="col-md-3" >
          <div class="form-group">
            <label for="sensorId" class="custom-label">Tag Number</label>
            <input id="sensorId" type="text" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.physicalid" @input="clearErrorMessage">
            <small v-if="!saveData.physicalid" style="font-size: 10px; color: red;">Enter a text</small>
            <div v-if="errorMessage" class="text-danger " style="font-size: 11px;">{{ errorMessage }}</div>
          </div>
        </div>
        <div class="col-md-4 mb-3" >
          <div class="form-group">
            <label class="custom-label">Sensor Type</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.sensortypeid">
              <option v-for="sensorType in sensorTypes" :key="sensorType.uuid" :value="sensorType.uuid">{{
                sensorType.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-4 mb-3" >
          <div class="form-group">
            <label class="custom-label">Device</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.deviceid">
              <option v-for="device in devices" :key="device.uuid" :value="device.uuid">{{ device.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-4 mb-3" >
          <div class="form-group">
            <label class="custom-label">Meter Type</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model.number="saveData.metertype">
              <option v-for="sensor in sensorSpecs" :key="sensor.code" :value="sensor.code">{{ sensor.type }}</option>
            </select>
          </div>
        </div>
        <div>
          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label class="custom-label">Flow Rate Unit</label>
                <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
                  v-model.number="saveData.flowrateunit">
                  <option v-for="flow in flowRate" :key="flow.code" :value="flow.code">{{ flow.type }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label class="custom-label">Total Unit</label>
                <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
                  v-model.number="saveData.totalunit">
                  <option v-for="total in totals" :key="total.code" :value="total.code">{{ total.type }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label class="custom-label">Equivalent ID</label>
                <input id="" class="form-control shadow-none custom-input" placeholder="Enter text"
                  v-model="saveData.equivalentid">
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="flowMeterRate" class="custom-label">Flow Coefficient</label>
                <input id="flowMeterRate" class="form-control shadow-none custom-input" placeholder="Enter text"
                  v-model="saveData.flowcofficient">
              </div>
            </div>
            <div class="col-md-2 ">
              <div class="form-group">
                <label for="flowMeterRate" class="custom-label">Low Flow Cutoff</label>
                <input id="flowMeterRate" class="form-control shadow-none custom-input" placeholder="Enter text"
                  v-model="saveData.lowflowcutoff">
              </div>
            </div>
            <div class="col-md-2" :class="{ 'mb-3': isValidFloat(saveData.density) }">
              <div class="form-group">
                <label for="flowMeterRate" class="custom-label">Density SC</label>
                <input id="flowMeterRate" class="form-control shadow-none custom-input" placeholder="Enter value"
                  v-model.number="saveData.density">
                <small v-if="!isValidFloat(saveData.density)" style="font-size: 10px; color: red;">Enter a float
                  value.</small>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="flowMeterRate" class="custom-label">Medium</label>
                <input id="flowMeterRate" class="form-control shadow-none custom-input" placeholder="Enter text"
                  v-model="saveData.flow_medium">
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="flowMeterRate" class="custom-label">Meter Factor</label>
                <input id="flowMeterRate" class="form-control shadow-none custom-input" placeholder="Enter text"
                  v-model="saveData.meterfactor">
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="flowMeterRate" class="custom-label">Full Scale Flow</label>
                <input id="flowMeterRate" class="form-control shadow-none custom-input" placeholder="Enter text"
                  v-model="saveData.fullscaleflow">
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="flowMeterRate" class="custom-label">Address</label>
                <input id="flowMeterRate" class="form-control shadow-none custom-input" placeholder="Enter text"
                  v-model="saveData.address">
              </div>
            </div>
            <div class="col-md-2" :class="{ 'mb-3': isValidInteger(saveData.boudrate) }">
              <div class="form-group">
                <label for="flowMeterRate" class="custom-label">Boud Rate</label>
                <input id="flowMeterRate" class="form-control shadow-none custom-input" placeholder="Enter value"
                  v-model.number="saveData.boudrate">
                <small v-if="!isValidInteger(saveData.boudrate)" style="font-size: 10px; color: red;"> Enter a integer
                  value.</small>
              </div>
            </div>
            <div class="col-md-2" :class="{ 'mb-3': isValidDateTime(saveData.dateandtime) }">
              <div class="form-group">
                <label for="flowMeterRate" class="custom-label">Date and Time</label>
                <input id="flowMeterRate" class="form-control shadow-none custom-input" placeholder="Enter text"
                  v-model="saveData.dateandtime">
                <small v-if="!isValidDateTime(saveData.dateandtime)" style="font-size: 10px; color: red;">Note:
                  YYYY-MM-DD HH:MM:SS</small>
              </div>
            </div>


            <div class="col-md-2">
              <div class="form-group">
                <label for="flowMeterRate" class="custom-label">Zero Volt</label>
                <input id="flowMeterRate" class="form-control shadow-none custom-input" placeholder="Enter text"
                  v-model="saveData.zerovolt">
              </div>
            </div>
            <div class="col-md-2 mb-3">
              <div class="form-group">
                <label for="flowMeterRate" class="custom-label">R Value</label>
                <input id="flowMeterRate" class="form-control shadow-none custom-input" placeholder="Enter text"
                  v-model="saveData.resistancevalue">
              </div>
            </div>
            
          </div>
        </div>
        <div class="col-md-12 mb-3" >
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Description</label>
            <textarea id="assetTypeNote" rows="4" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.description"></textarea>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Notes</label>
            <textarea id="assetTypeNote" rows="4" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.note"></textarea>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="sensor-details-label" style="font-size: 14px;">Select OP Range</label>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-check form-check-inline">
            <input class="form-check-input shadow-none" type="radio" name="inlineRadioOptions" id="inlineRadio1"
              :value="'Low'" v-model="saveData.optemp">
            <label class="form-check-label custom-label" for="inlineRadio1">Low</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input shadow-none" type="radio" name="inlineRadioOptions" id="inlineRadio2"
              :value="'Medium'" v-model="saveData.optemp">
            <label class="form-check-label custom-label" for="inlineRadio2">Medium</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input shadow-none" type="radio" name="inlineRadioOptions" id="inlineRadio2"
              :value="'High'" v-model="saveData.optemp">
            <label class="form-check-label custom-label" for="inlineRadio2">High</label>
          </div>

        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="sensor-details-label" style="font-size: 14px;">Sensor Rule</label>
          </div>
        </div>
        <div class="col-md-12 mb-3 me-4">
          <div class="form-check form-switch">
            <input class="form-check-input shadow-none " type="checkbox" id="flexSwitchCheckDefault" :true-value="1"
              :false-value="0" v-model="saveData.isalarm">
            <label class="form-check-label custom-input" for="flexSwitchCheckDefault"> {{ saveData.isalarm ? 'Alarm On'
              : 'Alarm Off' }}</label>
          </div>
        </div>
       
        <div class="col-md-6">
          <div class="form-group">
            <label class="custom-label">Low Cutoff Percentage</label>

            <input id="lowcutoff" class="form-control shadow-none custom-input" placeholder="Enter Value"
              v-model.number="saveData.lowcuttoff">
            <small v-if="!isValidInteger(saveData.lowcuttoff)" style="font-size: 10px; color: red;"> Enter a integer
              value.</small>
          </div>
        </div>
        <div class="col-md-6 mb-3" >
          <div class="form-group">
            <label class="custom-label">High Cutoff Percentage</label>
            <input id="highcutoff" class="form-control shadow-none custom-input" placeholder="Enter Value"
              v-model.number="saveData.highcuttoff">
            <small v-if="!isValidInteger(saveData.highcuttoff)" style="font-size: 10px; color: red;"> Enter a integer
              value.</small>
          </div>
        </div>
        <div class="col-md-12 mb-3" >
          <div class="form-check form-check-inline">
            <input class="form-check-input shadow-none" type="checkbox" name="inlineRadioOptions" id="inlineRadio2"
              :true-value="1" :false-value="0" checked disabled v-model="saveData.isautomanage">
            <label class="form-check-label custom-label" for="inlineRadio2">Auto Manage</label>
          </div>
          <div class="form-check form-check-inline">
            <p class="form-check-label custom-label" for="inlineRadio2" style="color: red;">If the sensor returns to
              normal condition then auto managed.</p>
          </div>
        </div>
        <!-- <div class="col-md-11 ">
          <div class="form-group">
            <label for="assetTypeNote" class="sensor-details-label" style="font-size: 14px;">Sensor Details</label>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-end mb-3">
          <div class="form-group">
            <button @click="addTask" class="btn btn-sm task-button">Add+</button>
          </div>
        </div>
        <div class="col-md-12">

          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="custom-label">
                  <td scope="col">Sensor Type</td>
                  <td scope="col">Range Min</td>
                  <td scope="col">Range Max</td>
                  <td scope="col" width="15"></td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(task, index) in sensorDetails" :key="index">
                  <td class="align-middle"> 
                    <input type="text" class="form-control custom-input shadow-none" v-model="task.type">
                  </td>
                  <td class="align-middle"> 
                    <input type="text" class="form-control custom-input shadow-none" v-model="task.minvalue">
                  </td>
                  <td class="align-middle"> 
                    <input type="text" class="form-control custom-input shadow-none" v-model="task.maxvalue">
                  </td>
                  <td class="align-middle">
                    <button @click="deleteTask(index)"
                      class="btn form-control d-flex justify-content-center align-items-center p-0 task-delete-button">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="red" class="bi bi-trash"
                        viewBox="0 0 16 16">
                        <path
                          d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                        <path
                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                      </svg>
                    </button>

                  </td>


                </tr>

              </tbody>
            </table>
          </div>
        </div> -->

        <div class="col-md-3" v-if="this.sensorId">
          <div class="form-group">
            <button type="button" class="btn btn-danger btn-sm delete-button" data-bs-toggle="modal"
              data-bs-target="#exampleModal">Delete</button>
          </div>
        </div>

        <!-- Modal -->
        <deleteModal v-if="this.sensorId" :deleteRecord="deleteRecord" />
        <div class="col-md-8 d-flex justify-content-end" v-if="this.sensorId">

          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-11 d-flex justify-content-end" v-else>
          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-start">
          <div class="form-group">
            <button  type="submit" class="btn btn-primary btn-sm submit-button"
              :disabled="!saveData.physicalid || !isValidFloat(saveData.density) || !isValidInteger(saveData.boudrate) || !isValidInteger(saveData.lowcuttoff) || !isValidInteger(saveData.highcuttoff) || !isValidDateTime(saveData.dateandtime)"
              @click="addSensorData">Submit</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Subheader from '@/components/Subheader.vue'
import { ddDevice, ddSensorType,addSensor, getByIdSensor, updateSensor } from '@/http/iot-sensors/sensor.http'
import { ddSensorSpec, ddFlowrateUnit, ddTotalUnit } from '@/http/iot-sensors/sensor-type.http'
import deleteModal from '@/components/delete-modal.vue';
export default {
  name: 'sensor-form',
  components: {
    Header,
    Subheader,
    deleteModal
  },
  data() {
    return {
      errorMessage: "",
      breadcrumsfirst: "IoT Sensors",
      breadcrumslast: "Sensor",
      // titleConfig:"Add Asset Type",
      sensorId: this.$route.params.id,
      saveData: {
        optemp: "Medium"
      },
      devices: [],
      sensorSpecs: [],
      flowRate: [],
      totals: [],
      dateTimeRegex: /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/,
      sensorTypes: [],
      // sensorDetails: [
      //   {
      //     type: '',
      //     minvalue: '',
      //     maxvalue: ''
      //   },
      // ]
    }
  },
  async mounted() {
    await this.getDeviceDropdownData();
    await this.getSensorSpecDropdownData();
    await this.getflowRateUnitDropdownData();
    await this.getTotalDropdownData();
    await this.getSensorTypeDropdownData();
    await this.getDetailData();
  },

  methods: {
    addSensorData() {

      const payloadUpdate = {
        uuid: this.$route.params.id,
        // type: this.sensorDetails.map(task => task.type),
        // minvalue: this.sensorDetails.map(task => String(parseInt(task.minvalue))),
        // maxvalue: this.sensorDetails.map(task => String(parseInt(task.maxvalue))),
        isalarm: this.saveData.isalarm ? 1 : 0,
        isautomanage: 1,
        issoftdelete: 0
      };
      if (this.sensorId) {
        updateSensor({ ...this.saveData, ...payloadUpdate }).then(() => {
          this.saveData.updatedon = new Date().toISOString();
          this.$router.push("/iotsensors/sensor")
        }).catch(error => {
          if (error.response && error.response.status === 401 && error.response.data && error.response.data.message === "physicalid is already exist") {
            // Store error message
            this.errorMessage = "Tag number already exists";
          } else {
            console.error('Error adding sensor:', error);
            // Handle other errors (e.g., display generic error message)
          }
        });
      } else {
        const payloadAdd = {
          // type: this.sensorDetails.map(task => task.type),
          // minvalue: this.sensorDetails.map(task => parseInt(task.minvalue)),
          // maxvalue: this.sensorDetails.map(task => parseInt(task.maxvalue)),
          isalarm: this.saveData.isalarm ? 1 : 0,
          isautomanage: 1
        };
        addSensor({ ...this.saveData, ...payloadAdd }).then(() => {
          this.$router.push("/iotsensors/sensor")
        }).catch(error => {
          if (error.response && error.response.status === 401 && error.response.data && error.response.data.message === "physicalid is already exist") {
            // Store error message
            this.errorMessage = "Tag number already exists";
          } else {
            console.error('Error adding sensor:', error);
            // Handle other errors (e.g., display generic error message)
          }
        });
      }

    },
    async getSensorTypeDropdownData() {
      try {
        const response = await ddSensorType();
        this.sensorTypes = response;
        if (this.sensorTypes.length > 0) {
          if (this.sensorId) {
            const index = this.sensorTypes.findIndex(sensorType => sensorType.uuid === this.saveData.sensortypeid);
            if (index !== -1) {
              this.saveData.sensortypeid = this.sensorTypes[index].uuid;
            }
          } else {
            this.saveData.sensortypeid = this.sensorTypes[0].uuid;
          }
        }
      } catch (error) {
        console.error('Error fetching sensor type:', error);
      }
    },
    async getSensorSpecDropdownData() {
      try {
        const response = await ddSensorSpec();
        this.sensorSpecs = response;
        if (this.sensorSpecs.length > 0) {
          if (this.sensorTypeId) {
            const index = this.sensorSpecs.findIndex(sensor => sensor.code === this.saveData.metertype);
            if (index !== -1) {
              this.saveData.metertype = this.sensorSpecs[index].code;
            }
          } else {
            this.saveData.metertype = this.sensorSpecs[0].code;
          }
        }
      } catch (error) {
        console.error('Error fetching assets:', error);
      }
    },
    async getflowRateUnitDropdownData() {
      try {
        const response = await ddFlowrateUnit();
        this.flowRate = response;
        if (this.flowRate.length > 0) {
          if (this.sensorTypeId) {
            const index = this.flowRate.findIndex(flow => flow.code === this.saveData.flowrateunit);
            if (index !== -1) {
              this.saveData.flowrateunit = this.flowRate[index].code;
            }
          } else {
            this.saveData.flowrateunit = this.flowRate[0].code;
          }
        }
      } catch (error) {
        console.error('Error fetching assets:', error);
      }
    },
    async getTotalDropdownData() {
      try {
        const response = await ddTotalUnit();
        this.totals = response;
        if (this.totals.length > 0) {
          if (this.sensorTypeId) {
            const index = this.totals.findIndex(total => total.code === this.saveData.totalunit);
            if (index !== -1) {
              this.saveData.totalunit = this.totals[index].code;
            }
          } else {
            this.saveData.totalunit = this.totals[0].code;
          }
        }
      } catch (error) {
        console.error('Error fetching assets:', error);
      }
    },
    async getDeviceDropdownData() {
      try {
        const response = await ddDevice();
        this.devices = response;
        if (this.devices.length > 0) {
          if (this.sensorId) {
            const index = this.devices.findIndex(device => device.uuid === this.saveData.deviceid);
            if (index !== -1) {
              this.saveData.deviceid = this.devices[index].uuid;
            }
          } else {
            this.saveData.deviceid = this.devices[0].uuid;
          }
        }
      } catch (error) {
        console.error('Error fetching device:', error);
      }
    },
    async getDetailData() {
      if (this.sensorId) {
        try {
          const response = await getByIdSensor(this.sensorId);
          this.saveData = response;
          this.saveData.deviceid = response.deviceid;
          this.saveData.sensortypeid = response.sensortypeid;
          this.saveData.isautomanage = response.isautomanage;
          this.saveData.isalarm = response.isalarm;

          // Clear existing sensorDetails
          this.sensorDetails = [];

          // Loop through 'type', 'minvalue', and 'maxvalue' arrays
          // for (let i = 0; i < response.type.length; i++) {
          //   this.sensorDetails.push({
          //     type: response.type[i],
          //     minvalue: response.minvalue[i],
          //     maxvalue: response.maxvalue[i]
          //   });
          // }
        } catch (error) {
          console.error('Error fetching detail data:', error);
        }
      }
    },
    cancelButton() {
      this.$router.push("/iotsensors/sensor")
    },
    deleteRecord() {
      const payloadUpdate = {
        uuid: this.$route.params.id,
        isalarm: this.saveData.isalarm ? 1 : 0,
        isautomanage: 1,
        issoftdelete: 1
      };
      if (this.sensorId) {
        updateSensor({ ...this.saveData, ...payloadUpdate }).then(() => {
          this.saveData.updatedon = new Date().toISOString();
          this.$router.push("/iotsensors/sensor")
        }).catch(error => {
          if (error.response && error.response.status === 401 && error.response.data && error.response.data.message === "physicalid is already exist") {
            // Store error message
            this.errorMessage = "Tag number already exists";
          } else {
            console.error('Error adding sensor:', error);
            // Handle other errors (e.g., display generic error message)
          }
        });
      }
    },
   
   
    isValidInteger(value) {
      // Check if the value is a valid integer
      return Number.isInteger(value) && value >= 0; // Assuming "Boud Rate" is non-negative
    },
  isValidFloat(value) {
  // Ensure value is a valid float and non-negative, including 0.0
  return !isNaN(value) && parseFloat(value) >= 0 && (parseFloat(value) !== Math.floor(value) || value === 0.0);
},
    isValidDateTime(dateTime) {
      // Check if the dateTime matches the format YYYY-MM-DD HH:MM:SS
      return this.dateTimeRegex.test(dateTime);
    },
    // addTask() {
    //   this.sensorDetails.push({
    //     type: '',
    //     minvalue: '',
    //     maxvalue: ''
    //   });
    // },
    deleteTask(index) {
      this.sensorDetails.splice(index, 1);
    },
    clearErrorMessage() {
      this.errorMessage = ""; // Clear the errorMessage
    },
  }
}
</script>

<style scoped>
.task-button {
  color: #fff;
  padding: 5px 8px;
  background-color: #1371E7;
  border: 1px solid #1371E7;
  border-radius: 5px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  cursor: pointer;
  font-family: "Mulish", sans-serif;
  font-size: 11px;
  font-weight: 500;
}

.task-delete-button {
  border: none;
}

.sensor-details-label {
  font-size: 14px;
  font-weight: 600;
}
</style>